import React, { createRef } from 'react';
import { IonButton, IonInput, IonChip, IonSearchbar, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonModal, IonLoading } from '@ionic/react';
import '../styles/Statistics.scss';
import { Swiper, Slide } from 'react-dynamic-swiper'
import 'react-dynamic-swiper/lib/styles.css'
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import ReactCardFlip from 'react-card-flip';
import Utilities from '../Utilities';
import { folder, star, book, eye, pricetag, fileTrayFull, albums, close, image, checkmarkCircle, closeCircle, syncCircle, flash, flashOff, link, chevronBackCircle, chevronForwardCircle, playCircle, checkmarkDone, checkmarkDoneCircle, notifications, analytics, grid, language, expand } from 'ionicons/icons'
import Chart from './Chart';
import ChartActivity from './ChartActivity';
import BubbleUI from "react-bubble-ui";
import "react-bubble-ui/dist/index.css";
import domtoimage from 'dom-to-image';
import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';
import { Clipboard } from '@capacitor/clipboard';

const options = {
    size: 140,
    minSize: 20,
    gutter: 8,
    provideProps: true,
    numCols: 4,
    fringeWidth: 160,
    yRadius: 130,
    xRadius: 130,
    cornerRadius: 107,
    showGuides: false,
    compact: true,
    gravitation: 5
}

const expandedOptions = {
    ...options,
    yRadius: 200,
    xRadius: 200
}

class Importer extends React.Component {

    constructor(props) {
        super(props);
        this.state = { }
    }

    async ionViewWillEnter() {
        this.setState({
            loading: true
        })

        if (!window.db || !store || !store.getState() || !store.getState().calendar || !store.getState().calendar.studysetsFormatted) {
            setTimeout(() => {
                this.ionViewWillEnter();
            }, 50);
            return;
        }

        try {
            let newCardCount = 0;
            const res = await Clipboard.read();
            if (res && res.value && res.value.startsWith('flashcardsmadesimple.com|')) {
                const obj = JSON.parse(res.value.replace('flashcardsmadesimple.com|', ''));
                console.log(obj)

                const reduxStudysets = store.getState().calendar.studysetsFormatted;
                const allImportedCardIds = await SQLStorage.getAllCardIds();
                
                for (let i = 0; i < obj.sets.length; i++) {
                    const set = obj.sets[i];
                    if (reduxStudysets.find(s => s.id === set.id)) {
                        console.log("@ Studyset already exists: " + set.id);
                    } else {
                        console.log("@ Creating studyset: " + set.id);
                        await SQLStorage.saveSet({
                            name: set.name,
                            term: set.sourceLang, // TODO needs full lang for ponunciation
                            definition: set.targetLang,
                            createdAt: new Date(),
                            updatedAt: new Date(),
                            id: set.id,
                        });
                        await window.dropbox.queueForUpload("set", set.id)
                    }
                }

                let  queueForUploadList = [];

                for (let i = 0; i < obj.cards.length; i++) {
                    const card = obj.cards[i];
                    if (allImportedCardIds.indexOf(card.id) !== -1) {
                        console.log("@ Card already exists: " + card.id);
                    } else {
                        newCardCount++;
                        console.log("@ Creating card: " + card.id);
                        let newCard = {
                            id: card.id,
                            term: card.term,
                            definition: card.definition,
                            tags: [],
                            createdAt: new Date(card.createdAt),
                            updatedAt: new Date(card.createdAt),
                            setId: card.setId,
                            strength: "0",
                            history: [],
                            customText2: [],
                            links: []
                        };
                        
                        await SQLStorage.saveCard(card, false, true);
                        queueForUploadList.push(["card", card.id + "-" + card.setId]);
                    }
                }

                await window.dropbox.queueForUpload(queueForUploadList);

                if (newCardCount > 0) {
                    store.dispatch(updatedSetsSet(obj.sets.map(s => s.id)));
                    window.toast("Imported " + newCardCount + " new cards");
                }
                this.props.history.push("/sets")
                this.setState({
                    loading: false
                })
            }
        } catch (e) {
            console.error(e);
            this.setState({
                loading: false
            })
            this.props.history.push("/sets")
        }
    }

    render() {
        return (
            <IonPage data-page="import">
                <IonContent>
                </IonContent>
                <IonLoading
                    isOpen={this.state.loading}
                    message={window.ln.loading}
                    duration={10000}
                />
            </IonPage>
        );
    }

};


export default withIonLifeCycle(Importer);
